import { CASES_WEBHOOK_URL } from "../../Constants";
import { axiosClientCases } from "../AxiosClient";

const CASES_PATH = "/v1/cases";

export const createVideollamadaCase = (name, documentNumber) =>
  axiosClientCases
    .post(CASES_PATH, {
      webhook_url: CASES_WEBHOOK_URL,
      applicant: {
        name,
        document_number: documentNumber,
      },
      metadata: {
        source: "prami-frontend",
      },
    })
    .then((response) => response.data);
